import { Component } from "./component";

export class Coloring {
    /**
     *  Color of the components
     */
    public color: string;

    /**
     * Colored components
     */
    public components: Component[];
}